import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// components
import TableError from 'components/TableError';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import { createStructuredSelector } from 'reselect';
import { ACTION_TAKEN_ARRAY, ACTIVE_AND_DELETED_ARRAY, SORT_VALUES } from 'utils/constants';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Loader from '../../../components/Loader';
import Paginate from '../../../components/Paginate';
import SchoolAutoComplete from '../../../components/SchoolAutoComplete';
import useRequest from '../../../hooks/useRequest';
import { useRouter } from '../../../hooks/useRouter';

// helpers
import {
  buildURL,
  checkIfValueExist,
  convertHtmlToText,
  formatInputDate,
  getCurrentUserData,
  getFormattedDate,
  getImageUrl,
  printDateTime,
  printDateTimeTwoLines,
  printSerialNumbers,
} from '../../../utils/helper';
import { getCities, getCountries, getRegions, getSubAreas } from '../actions';
import { citiesSelector, countriesSelector, regionsSelector, subAreasSelector } from '../selectors';
import classNames from 'classnames';
import { SMKLinks } from 'utils/links';
import { Link } from 'react-router-dom';

const stateSelector = createStructuredSelector({
  countries: countriesSelector,
  regions: regionsSelector,
  cities: citiesSelector,
  subAreas: subAreasSelector,
});

const SchoolCommunityPosts = () => {
  const router = useRouter();
  const history = useHistory();
  const dispatch = useDispatch();
  toast.configure();
  const { countries, regions, cities, subAreas } = useSelector(stateSelector);
  const { stgURL } = getCurrentUserData();

  const [schoolCommentsList, setSchoolCommentsList] = useState([]);
  const [schoolCommentsPagination, setSchoolCommentsPagination] = useState({});

  //   const [selectedSchool, setSelectedSchool] = useState(null);

  //   const defaultFilters = {
  //     active: true,
  //     deleted: { value: null, label: 'All' },
  //     startDate: formatInputDate(moment().subtract(1, 'year')),
  //     endDate: formatInputDate(moment()),

  //     countryId: undefined,
  //     regionId: undefined,
  //     cityId: undefined,
  //     subAreaId: undefined,
  //   };

  //   const [filters, setFilters] = useState(defaultFilters);

  const [getSchoolCommentsRequest, { loading: getSchoolCommentsLoading }] = useRequest({
    url: '/school/admin/admissionInquiry/get-community-comments',
    method: 'POST',
    onSuccess: (data) => {
      setSchoolCommentsList(data?.result);
      setSchoolCommentsPagination(data?.pagination);
    },
  });

  const setPageInUrl = (page) => {
    history.push({
      pathname: router.pathname,
      search: `?${new URLSearchParams({ page }).toString()}`,
    });
  };

  const handleChangePage = (page) => {
    setPageInUrl(page);
    getSchoolCommentsRequest({
      body: {
        page,
        size: 20,
      },
    });

    // const data = {
    //   ...filters,
    // };

    // if (filters.countryId == '') {
    //   data.countryId = undefined;
    // } else if (filters.countryId) {
    //   data.countryId = filters.countryId.id;
    // }
    // if (filters.regionId == '') {
    //   data.regionId = undefined;
    // } else if (filters.regionId) {
    //   data.regionId = filters.regionId.id;
    // }
    // if (filters.cityId == '') {
    //   data.cityId = undefined;
    // } else if (filters.cityId) {
    //   data.cityId = filters.cityId.id;
    // }
    // if (filters.subAreaId == '') {
    //   data.subAreaId = undefined;
    // } else if (filters.subAreaId) {
    //   data.subAreaId = filters.subAreaId.id;
    // }

    // getSchoolCommentsRequest({
    //   body: {
    //     page,
    //     ...data,
    //     size: 20,
    //     active: checkIfValueExist(filters?.active?.value),
    //     deleted: checkIfValueExist(filters?.deleted?.value),
    //   },
    // });
  };

  useEffect(() => {
    handleChangePage(parseInt(router?.query?.page, 10) || 1);
    // dispatch(getCountries.trigger({ level: 0, page: 1, size: 500, sortBy: 'slug', sortOrder: 0 }));
  }, []);

  //   const applyFilters = () => {
  //     handleChangePage(1);
  //   };

  //   const clearFilters = () => {
  //     setPageInUrl(1);

  //     setFilters({
  //       ...defaultFilters,
  //       countryId: '',
  //       regionId: '',
  //       cityId: '',
  //       subAreaId: '',
  //     });

  //     getSchoolCommentsRequest({
  //       body: {
  //         ...defaultFilters,
  //         ...SORT_VALUES,
  //         page: 1,
  //         size: 20,
  //         active: checkIfValueExist(defaultFilters?.active?.value),
  //         deleted: checkIfValueExist(defaultFilters?.deleted?.value),
  //       },
  //     });
  //     setSelectedSchool(null);

  //     getSchoolCommentsRequest({
  //       body: {
  //         page: 1,
  //         size: 20,
  //       },
  //     });
  //   };

  //   const onCountrySelect = (country) => {
  //     if (!isEmpty(country)) {
  //       dispatch(
  //         getRegions.trigger({
  //           level: 1,
  //           country: country.name,
  //           page: 1,
  //           size: 500,
  //           sortBy: 'slug',
  //           sortOrder: 0,
  //         })
  //       );
  //       setFilters({ ...filters, countryId: country });
  //     } else {
  //       setFilters({ ...filters, countryId: undefined });
  //     }
  //   };
  //   const onRegionSelect = (region) => {
  //     if (!isEmpty(region)) {
  //       dispatch(
  //         getCities.trigger({
  //           level: 3,
  //           cityOnly: true,
  //           region: region.name,
  //           page: 1,
  //           size: 500,
  //           sortBy: 'slug',
  //           sortOrder: 0,
  //         })
  //       );

  //       setFilters({ ...filters, regionId: region });
  //     } else {
  //       setFilters({ ...filters, regionId: undefined });
  //     }
  //   };

  //   const onCitySelect = (city) => {
  //     if (!isEmpty(city)) {
  //       dispatch(getSubAreas.trigger({ level: 4, city: city.name, page: 1, size: 500, sortBy: 'slug', sortOrder: 0 }));

  //       setFilters({ ...filters, cityId: city });
  //     } else {
  //       setFilters({ ...filters, cityId: undefined });
  //     }
  //   };

  //   const onSubAreaSelect = (subArea) => {
  //     if (!isEmpty(subArea)) {
  //       setFilters({ ...filters, subAreaId: subArea });
  //     } else {
  //       setFilters({ ...filters, subAreaId: undefined });
  //     }
  //   };

  return (
    <>
      <div className="page-content">
        <Loader isActive={getSchoolCommentsLoading} />

        <Container fluid>
          <Breadcrumbs title="School Community" breadcrumbItem="School Community Posts" />

          {/* <Card>
            <CardBody>
              <div className="mt-4">
                <div className="row">
                  <div className="col-lg-3 mb-4">
                    <label className="form-label">Active</label>
                    <Select
                      options={ACTION_TAKEN_ARRAY}
                      value={filters.active}
                      onChange={(value) => setFilters({ ...filters, active: value })}
                    />
                  </div>
                  <div className="col-lg-2 mb-4">
                    <label className="form-label">Deleted</label>
                    <Select
                      options={ACTIVE_AND_DELETED_ARRAY}
                      value={filters.deleted}
                      onChange={(value) => setFilters({ ...filters, deleted: value })}
                    />
                  </div>
                  <div className="col-lg-2 mb-4">
                    <label className="form-label">Created Date - From</label>
                    <Input
                      type="date"
                      name="startDate"
                      placeholder="From Date"
                      value={filters.startDate}
                      max={moment().format('YYYY-MM-DD')}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          startDate: formatInputDate(e.target.value),
                        })
                      }
                    />
                  </div>
                  <div className="col-lg-2 mb-4">
                    <label className="form-label">Created Date - To</label>
                    <Input
                      type="date"
                      name="endDate"
                      placeholder="To Date"
                      value={filters.endDate}
                      max={moment().format('YYYY-MM-DD')}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          endDate: formatInputDate(e.target.value),
                        })
                      }
                    />
                  </div>
                  <div className="col-lg-3 mb-4">
                    <label className="form-label">School</label>

                    <SchoolAutoComplete
                      selectedSchool={selectedSchool}
                      onSelectSchool={(school) => {
                        if (school?.id > 0) {
                          setFilters({ ...filters, schoolId: school.id });
                        } else {
                          const newFilters = { ...filters };
                          delete newFilters.schoolId;
                          setFilters(newFilters);
                        }
                        setSelectedSchool(school);
                      }}
                    />
                  </div>
                </div>

                <Row className="mt-4">
                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="school_country" className="form-label">
                        Country
                      </Label>
                      <Select
                        isClearable
                        id="school_country"
                        options={countries}
                        value={filters.countryId}
                        onChange={onCountrySelect}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="school_state" className="form-label  ">
                        Region/State
                      </Label>

                      <Select
                        isClearable
                        id="school_state"
                        placeholder="Select..."
                        value={filters.regionId}
                        onChange={onRegionSelect}
                        options={regions}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="school_city" className="form-label  ">
                        City
                      </Label>
                      <Select
                        isClearable
                        id="school_city"
                        placeholder="Select..."
                        value={filters.cityId}
                        onChange={onCitySelect}
                        options={cities}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup className="mb-4">
                      <Label for="school_area" className="form-label  ">
                        SubArea
                      </Label>
                      <Select
                        isClearable
                        id="school_area"
                        placeholder="Select..."
                        value={filters.subAreaId}
                        onChange={onSubAreaSelect}
                        options={subAreas}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <div className="mt-4">
                <a className="btn btn-primary me-4" onClick={applyFilters}>
                  Apply Filters
                </a>
                <a className="" onClick={clearFilters}>
                  Clear
                </a>
              </div>
            </CardBody>
          </Card> */}

          <Row className="mb-2">
            <Col sm="4">
              <div className="search-box me-2 mb-2 d-inline-block">
                <div className="position-relative font-bold">
                  {schoolCommentsPagination.totalCount || 0} School Posts Found
                </div>
              </div>
            </Col>
          </Row>

          {/* <Row>
            <Col lg="12">
              <div className="">
                {!isEmpty(schoolCommentsList) ? (
                  schoolCommentsList?.map((data, index) => (
                    <div key={`post_${index + 1}`}>
                      <Card className={`mb-3 rounded-4 ${data?.deleted ? 'bg-danger' : ''}`}>
                        <CardBody>
                          <div className="d-md-flex align-items-center justify-content-between mb-3">
                            <div>
                              <div className="d-flex">
                                {!isEmpty(data?.thumbnail_small) ? (
                                  <img
                                    src={`${stgURL}${data?.thumbnail_small}`}
                                    alt={data?.created_by_name}
                                    className="d-flex align-items-center justify-content-center border border-secondary rounded-circle mb-0"
                                    style={{ width: '40px', height: '40px' }}
                                  />
                                ) : (
                                  <figure
                                    className="d-flex align-items-center justify-content-center border border-secondary rounded-circle mb-0"
                                    style={{ width: '40px', height: '40px' }}>
                                    <span>{data?.created_by_name?.slice(0, 2).toUpperCase()}</span>
                                  </figure>
                                )}
                                <div className="ms-3">
                                  <h6 className="mb-1">{data?.created_by_name}</h6>
                                  <p className="text-secondary mb-0">{printDateTime(data?.created_date)}</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <p className="mb-2">
                              School Name: <b>{data?.school_name}</b>{' '}
                              {!isEmpty(data.school_slug) && (
                                <span className="ms-2">
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_SCHOOLMYKIDS_WEB_URL}/school/${data.school_slug}`}>
                                    <i className="bx bx-link-external fs-4" />
                                  </a>
                                </span>
                              )}
                            </p>
                            <p className="mb-0">
                              School Address: <b>{data?.full_address}</b>
                            </p>
                          </div>
                          <div
                            className="mb-0 comment_html_content p border-top pt-3"
                            dangerouslySetInnerHTML={{ __html: data?.content }}
                          />
                        </CardBody>
                      </Card>
                    </div>
                  ))
                ) : (
                  <div style={{ minHeight: 170 }} className="bg-white d-flex justify-content-center align-items-center">
                    <div className="text-center">
                      <i className="bx bxs-error" style={{ fontSize: '50px', color: '#ffbc42' }} />
                      <h5 className="mt-3 text-secondary">No Posts Found!</h5>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row> */}

          <Row>
            <Col lg="12">
              <div className="">
                <div className="table-responsive" style={{ minHeight: 300 }}>
                  <Table className="project-list-table  table-centered table-borderless">
                    <thead>
                      <tr className="table-warning">
                        <th scope="col">S.No.</th>
                        {/* <th scope="col">ID</th> */}
                        <th scope="col">CreatedBy</th>
                        <th scope="col">Created Date</th>
                        <th scope="col">School Name</th>
                        <th scope="col">School City</th>
                        <th scope="col">Message</th>
                        <th scope="col">isReply</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(schoolCommentsList) ? (
                        schoolCommentsList?.map((data, index) => (
                          <tr key={index} className={classNames({ 'bg-danger': data.deleted })}>
                            <td>{printSerialNumbers(schoolCommentsPagination)[index]}</td>
                            {/* <td>{data?.id}</td> */}
                            <td>{data?.created_by_name}</td>
                            <td className="text-nowrap">{printDateTimeTwoLines(data?.created_date)}</td>
                            <td>
                              {data?.school_name}
                              {!isEmpty(data.school_slug) && (
                                <span className="ms-2">
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href={`${process.env.REACT_APP_SCHOOLMYKIDS_WEB_URL}/school/${data.school_slug}`}>
                                    <i className="bx bx-link-external fs-4" />
                                  </a>
                                </span>
                              )}
                            </td>
                            <td>
                              {[data?.city_name, data?.region_name, data?.country_name]
                                ?.filter((e) => !isEmpty(e))
                                ?.join(', ')}
                            </td>
                            <td dangerouslySetInnerHTML={{ __html: data?.content }} />
                            <td>
                              <Badge className={`${!isEmpty(data?.comment_id) ? 'bg-success' : 'bg-danger'}`}>
                                {!isEmpty(data?.comment_id) ? 'Yes' : 'No'}
                              </Badge>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <TableError />
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>

          {!isEmpty(schoolCommentsList) && (
            <Paginate pageInfo={schoolCommentsPagination} onChangePage={handleChangePage} />
          )}
        </Container>
      </div>
    </>
  );
};

export default SchoolCommunityPosts;
